// Parallax

window.addEventListener('scroll', function() {
    let prevScrollpos = window.pageYOffset;
    const section1 = document.querySelector('.hero-text');
    section1.style.top = prevScrollpos * 0.2 + 'px';
});

// Animation w/ IntersectionObserver

const anim1 = document.querySelectorAll('.anim-1');
const anim2 = document.querySelectorAll('.anim-2');
const anim3 = document.querySelectorAll('.anim-3');
const anim4 = document.querySelectorAll('.anim-4');

let observer1 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.style.animation = `anim1 1s ${entry.target.dataset.delay} forwards ease-out`;
        } else {
            entry.target.style.animation = `none`;
        }
    });
});
let observer2 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.style.animation = `anim2 1s ${entry.target.dataset.delay} forwards ease-out`;
        } else {
            entry.target.style.animation = `none`;
        }
    });
});
let observer3 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.style.animation = `anim3 1s ${entry.target.dataset.delay} forwards ease-out`;
        } else {
            entry.target.style.animation = `none`;
        }
    });
});
let observer4 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.style.animation = `anim4 0.7s ${entry.target.dataset.delay} forwards ease-out`;
        } else {
            entry.target.style.animation = `none`;
        }
    });
});

anim1.forEach(anim => {
    observer1.observe(anim);
});
anim2.forEach(anim => {
    observer2.observe(anim);
});
anim3.forEach(anim => {
    observer3.observe(anim);
});
anim4.forEach(anim => {
    observer4.observe(anim);
});

// const backToTop = document.querySelector('.back-to-top');

// window.addEventListener('scroll', function() {
//     if (window.scrollY >= 400) {
//         backToTop.classList.remove('hidden');
//     } else {
//         backToTop.classList.add('hidden');
//     }
// });


$(document).ready(function() {
    $('#contact-form').validate({
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true
            },
            message: 'required',
            accepted: 'required'
        },
        messages: {
            name: 'Please specify your name.',
            email: {
                required: 'We need your email address to contact you',
                email: 'Please provide valid email. Example: name@domain.com'
            },
            message: 'Please type message.'
        },
        submitHandler: function(form) {
            const url = $(form).attr('action');
            const formData = new FormData($(form)[0]);

            const submitButton = $(form).find('button[type="submit"]');

            $.ajax({
                url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: () => {
                    submitButton.attr('disabled', true);
                    submitButton.text('Sending ...');
                }
            }).done(function (data) {
                $(form).trigger('reset');

                submitButton.attr('disabled', false);
                submitButton.text('Send Message');

                notie.alert({
                    text: 'Thank you for reaching us. We will contact you shortly.',
                    type: 1,
                    position: 'bottom',
                    time: 2
                });
            }).fail( function(res) {
                submitButton.attr('disabled', false);
                submitButton.text('Send Message');

                notie.alert({
                    text: 'Sorry. An error occured while sending the message. Please try again.',
                    type: 3,
                    position: 'bottom'
                });
            });
        }
    });
});